/**
 * Station Context Composable
 * 用于在任何子组件中轻松访问电站上下文信息
 *
 * 使用方法：
 * import { useStationContext } from '@/views/station-monitor/composables/useStationContext'
 *
 * const { stationId, stationName, stationBaseData } = useStationContext()
 */

import { inject, computed } from 'vue'

export function useStationContext() {
  // 注入顶层提供的电站信息
  const stationId = inject('stationId', null)
  const stationName = inject('stationName', null)
  const stationBaseData = inject('stationBaseData', null)

  // 返回响应式的计算属性
  return {
    stationId: computed(() => stationId?.value || null),
    stationName: computed(() => stationName?.value || ''),
    stationBaseData: computed(() => stationBaseData?.value || {})
  }
}
